



















import Vue from "vue";
import Component from "vue-class-component";
import { MedicalInvoice } from "@/components/medicalEdit/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    EditDayChangePicker
  }
})
export default class InvoiceRange extends Vue {
  @Prop() tab!: MedicalInvoice;
}
